import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";

export const StallionExpressCarrierInput = groupInput({
  apiToken: input<string>({ validator: nonEmptyValidator }),
});

export type StallionExpressCarrierValue = InputSchema.Value<
  typeof StallionExpressCarrierInput
>;

export type StallionExpressCarrierForm = InputSchema.Input<
  typeof StallionExpressCarrierInput
>;

export const StallionExpressCarrierDefault =
  (): StallionExpressCarrierValue => ({ apiToken: "" });

export const CreateStallionExpressCarrierForm = memo(
  function CreateStallionExpressCarrierForm({
    carrierInput,
  }: {
    carrierInput: StallionExpressCarrierForm;
  }) {
    return (
      <RedoTextInput
        label="API token"
        placeholder=""
        setValue={carrierInput.inputs.apiToken.setValue}
        value={carrierInput.inputs.apiToken.value}
      />
    );
  },
);
